import { Box, Paper } from "@mui/material";
import type { FC, ReactNode } from "react";

export const SmsBubbleComponent: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Box sx={{ maxWidth: 500, padding: 2 }} data-testid="sms-bubble">
      <Paper
        elevation={1}
        sx={{
          padding: 3,
          backgroundColor: "#f0f0f0",
          borderRadius: 3,
          position: "relative",
          color: "black",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 20,
            left: -15,
            borderWidth: "15px 15px 15px 0",
            borderStyle: "solid",
            borderColor: "transparent #f0f0f0 transparent transparent",
            display: "block",
            width: 0,
          },
        }}
      >
        {children}
      </Paper>
    </Box>
  );
};
